module.exports = "mutation DeleteStoreComment($commentId:ID!){deleteComment:deleteStoreComment(commentId:$commentId){success}}"